function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TextInputMask } from "react-native-masked-text";
import { z } from "zod";
import { TextInput } from "./TextInput";
var TextInputWrapper = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var customTextInput = _param.customTextInput, customTextInputProps = _param.customTextInputProps, p = _object_without_properties(_param, [
        "customTextInput",
        "customTextInputProps"
    ]);
    return /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({}, p), {
        ref: ref
    }));
});
/**
 * An input field that allows the user to enter a US based phone number with
 * proper formatting / validation.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-110}
 */ export function PhoneInput(_param) {
    var value = _param.value, onChangeValue = _param.onChangeValue, props = _object_without_properties(_param, [
        "value",
        "onChangeValue"
    ]);
    return /*#__PURE__*/ _jsx(TextInputMask, {
        type: "custom",
        options: {
            mask: '(999) 999 - 9999'
        },
        customTextInput: TextInputWrapper,
        customTextInputProps: _object_spread({
            placeholder: '(555) 555 - 5555',
            inputMode: 'tel',
            autoCompleteType: 'tel'
        }, props),
        onChangeText: onChangeValue,
        value: value || ''
    });
}
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-110}
 */ export var PhoneInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    if (formContext && props.label) formContext.labels[name] = props.label;
    return /*#__PURE__*/ _jsx(PhoneInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        error: error === null || error === void 0 ? void 0 : error.message,
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value
    }, props));
};
/**
 * @nosync
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-110}
 */ export function PhoneFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return PhoneInputRender(props, rest);
        }
    });
}
